export enum CursorTypes {
  CUSTOM_CURSOR = 'custom-cursor',
  PREDETERMINED = 'predetermined',
}
